var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayBtnB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#4A60AB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.0004,
    cy: 27.0004,
    r: 21.1304,
    fill: "#3A52A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0006 48.131C38.6706 48.131 48.131 38.6706 48.131 27.0006C48.131 23.363 47.2118 19.9401 45.5931 16.9515C41.8782 13.7055 37.0168 11.7389 31.696 11.7389C20.026 11.7389 10.5656 21.1993 10.5656 32.8693C10.5656 36.5069 11.4847 39.9298 13.1034 42.9184C16.8183 46.1644 21.6798 48.131 27.0006 48.131Z",
    fill: "#4A60AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 27V23.9963C20.25 20.2669 22.8909 18.7397 26.1225 20.6044L28.7297 22.1063L31.3369 23.6082C34.5684 25.4729 34.5684 28.5272 31.3369 30.3919L28.7297 31.8938L26.1225 33.3957C22.8909 35.2604 20.25 33.7332 20.25 30.0038V27Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtnB);
export default __webpack_public_path__ + "static/media/play-btn-b.31ab9f11530b4f2de138f84794285802.svg";
export { ForwardRef as ReactComponent };